module.exports = __webpack_public_path__ + "img/collaborate_18.7b2f84d9.jpg";